import axios from "axios";
import { baseUrl } from "../util";

export const getAgreementGrantTokenEconomic = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  var config = {
    method: "get",
    url: baseUrl + "/api/business/user-agreement-grant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      token: token,
    },
  };

  axios(config)
    .then(function (response) {
      localStorage.setItem("economic_token", response.data.token);
    })
    .catch(function (error) {
      console.log(error);
    });
};
